import React, { FC } from 'react';

import { useTranslation } from 'app/lang';

import { MatchPeriodLabel } from '../MatchPeriodLabel';

import dictionary from './MatchNotStarted.dictionary.json';

type MatchNotStartedProps = {
  className?: string;
};

export const MatchNotStarted: FC<MatchNotStartedProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <MatchPeriodLabel className={className}>
      {t(dictionary.notStartedText)}
    </MatchPeriodLabel>
  );
};
